import api from "../index";
class MasterDataAPI {
    getListOptions = async () => {
        try {
            let listOptions = await api.get(`/opt/masterData`).then((res) => res.data);
            return {
                listOptions,
            }
        } catch (error) {
            console.error("Error fetching api getListOptions", error);
            throw error;
        }

    };
}

export const masterDataAPI = new MasterDataAPI()
